import React, { useState, useRef } from "react";
import PropTypes from "prop-types";

import { Row, Col, Modal, Button, Badge } from "react-bootstrap";
import { CompactPicker, CustomPicker, ChromePicker } from "react-color";
import { COMPACT_COLORS } from "../../constants";
import "./CustomColorPicker.css";

const CustomColorPicker = ({ color, handleChangeColor }) => {
  const customColorsRef = useRef([]);
  const [show, setShow] = useState(false);
  const [customColor, setCustomColor] = useState("");

  /**
   * Show/Close custom color modal
   */
  const handleVisibleModal = () => setShow(!show);

  /**
   * Change color value
   * @param {string} hex
   */
  const handleCustomColor = ({ hex }) => setCustomColor(hex);

  /**
   * Change color value
   * @param {string} hex
   */
  const handleSelectCustomColor = (value) => handleChangeColor({ hex: value });

  /**
   * Save change custom color and close modal
   */
  const handleSaveCustomColor = () => {
    if (customColor && !customColorsRef.current.includes(customColor)) {
      // Update list custom colors
      const colors = customColorsRef.current.concat(customColor);
      customColorsRef.current = colors;

      // Change color
      handleChangeColor({ hex: customColor });
    }

    // Close modal after save change
    handleVisibleModal();
  };

  return (
    <Col className="pt-1 pb-1 shadow bg-white rounded">
      <Row className="custom-compact-picker">
        <CompactPicker
          color={color}
          onChangeComplete={handleChangeColor}
          colors={COMPACT_COLORS}
        />
      </Row>
      <Row
        className="text-muted p-1 custom-color-btn d-inline-flex"
        onClick={handleVisibleModal}
      >
        Custom
      </Row>
      <Row>
        {customColorsRef.current.map((item) => (
          <Badge
            className="ml-1 custom-color d-flex align-items-center justify-content-center"
            style={{ backgroundColor: item }}
            key={item}
            onClick={() => handleSelectCustomColor(item)}
            data-testid={`custom-colors-${item}`}
          >
            {/* Show current custom color */}
            {item === color && (
              <span
                className="rounded"
                style={{
                  backgroundColor: item === "#ffffff" ? "#000" : "#fff",
                }}
                data-testid="custom-color-current"
              />
            )}
          </Badge>
        ))}
        <Button
          variant="outline-dark"
          onClick={handleVisibleModal}
          className="ml-1 p-0 d-flex align-items-center justify-content-center custom-color-icon"
        >
          +
        </Button>
      </Row>
      <Modal
        show={show}
        onHide={handleVisibleModal}
        centered={true}
        animation={false}
        dialogClassName="custom-color-modal justify-content-center"
        data-testid="select-custom-modal"
      >
        <Modal.Body bsPrefix="modal-body p-0" data-testid="select-custom-color">
          <ChromePicker
            color={customColor || color}
            onChangeComplete={handleCustomColor}
            disableAlpha
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-dark" onClick={handleVisibleModal}>
            Cancel
          </Button>
          <Button variant="dark" onClick={handleSaveCustomColor}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </Col>
  );
};

CustomColorPicker.propTypes = {
  color: PropTypes.string.isRequired,
  handleChangeColor: PropTypes.func.isRequired,
};

export default CustomPicker(CustomColorPicker);
